import React, { PropsWithChildren } from 'react';

export default function AkRed({ children }: PropsWithChildren<{}>) {
    return <span className='wwise-ak-red'>{children}</span>;
}
